import React from "react";

const Folder = () => (
  <svg
    width="28"
    height="25"
    viewBox="0 0 28 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.7685 7.66667H4.23143C2.67132 7.66667 1.44441 9.00007 1.57397 10.5548L2.46286 21.2215C2.57804 22.6036 3.73341 23.6667 5.12031 23.6667H22.8796C24.2665 23.6667 25.4219 22.6036 25.5371 21.2215L26.426 10.5548C26.5555 9.00007 25.3286 7.66667 23.7685 7.66667Z"
      stroke="#252828"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M24 6.33333V7.66667H3.99996V3.66667C3.99996 2.19391 5.19387 1 6.66663 1H9.56206C10.2693 1 10.9476 1.28095 11.4477 1.78105L13.3333 3.66667H21.3333C22.8061 3.66667 24 4.86057 24 6.33333Z"
      stroke="#252828"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

Folder.propTypes = {};

Folder.defaultProps = {};

export default Folder;
